import { useState } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const STREET_TILES = {
  url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  attribution: "&copy; OpenStreetMap contributors",
};
const SATELLITE_TILES = {
  url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
  attribution: "Tiles &copy; Esri — Source: Esri, Maxar, Earthstar Geographics",
};

const pinIcon = L.divIcon({
  className: "",
  html: '<div style="width:22px;height:22px;border-radius:50%;background:hsl(152,60%,28%);border:3px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4)"></div>',
  iconSize: [22, 22],
  iconAnchor: [11, 11],
});

const ClickHandler = ({ onPick }) => {
  useMapEvents({ click: (e) => onPick([e.latlng.lat, e.latlng.lng]) });
  return null;
};

export const PropertyPinMap = ({ lat, lng, onChange }) => {
  const hasCoords = lat != null && lng != null;
  const [pos, setPos] = useState(hasCoords ? [lat, lng] : null);
  const [satellite, setSatellite] = useState(false);
  const pick = (p) => { setPos(p); onChange(p); };
  const center = pos || [44.3, -78.75]; // Kawarthas default when nothing is pinned yet
  const tiles = satellite ? SATELLITE_TILES : STREET_TILES;
  return (
    <div data-testid="pin-map" className="relative">
      <MapContainer center={center} zoom={pos ? (satellite ? 18 : 15) : 7} style={{ height: 260, borderRadius: 8, zIndex: 0 }}>
        <TileLayer key={satellite ? "sat" : "street"} url={tiles.url} attribution={tiles.attribution} maxZoom={satellite ? 19 : 19} />
        <ClickHandler onPick={pick} />
        {pos && (
          <Marker position={pos} icon={pinIcon} draggable
            eventHandlers={{ dragend: (e) => { const ll = e.target.getLatLng(); pick([ll.lat, ll.lng]); } }} />
        )}
      </MapContainer>
      <button type="button" data-testid="satellite-toggle" onClick={() => setSatellite(!satellite)}
        className={`absolute right-2 top-2 z-[1000] rounded-md border px-3 py-2 text-xs font-bold shadow-md transition-colors ${satellite ? "border-primary bg-primary text-primary-foreground" : "border-border bg-card"}`}>
        {satellite ? "Street map" : "Satellite"}
      </button>
    </div>
  );
};
